import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-permission-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M4 6.66671V5.33337C4 3.12671 4.66667 1.33337 8 1.33337C11.3333 1.33337 12 3.12671 12 5.33337V6.66671"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M11.3334 14.6666H4.66671C2.00004 14.6666 1.33337 14 1.33337 11.3333V9.99996C1.33337 7.33329 2.00004 6.66663 4.66671 6.66663H11.3334C14 6.66663 14.6667 7.33329 14.6667 9.99996V11.3333C14.6667 14 14 14.6666 11.3334 14.6666Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M10.6643 10.6667H10.6703"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M7.99703 10.6667H8.00302"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M5.32967 10.6667H5.33566"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class PermissionIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 16 16');
}
